function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.636 21.5l-3.181 3 3.181 3M26.364 21.5l3.182 3-3.182 3M2.5 14h35",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5 5h-35v30h35V5z",
  stroke: "currentCOlor",
  strokeWidth: 3,
  strokeLinecap: "square"
});

var SvgBuilder = function SvgBuilder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    color: "#4038ff"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgc3R5bGU9ImNvbG9yOiM0MDM4RkY7IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTMuNjM2NCAyMS41TDEwLjQ1NDYgMjQuNUwxMy42MzY0IDI3LjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTI2LjM2NDMgMjEuNUwyOS41NDYxIDI0LjVMMjYuMzY0MyAyNy41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjxwYXRoIGQ9Ik0yLjUgMTRIMzcuNSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMzcuNSA1SDIuNVYzNUgzNy41VjVaIiBzdHJva2U9ImN1cnJlbnRDT2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+Cjwvc3ZnPgo=";
export { SvgBuilder as ReactComponent };